//@ts-check
import {
  TableCell,
  TableRow,
  TableSortLabel,
  makeStyles,
} from '@material-ui/core';
import React from 'react';
import { data } from './data';

import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    dropdown: {
      display: 'inline-grid',
      margin: '-20px 0',
    },
    show: {
      visibility: 'visible',
    },
    hide: {
      visibility: 'hidden',
    },
    arrowFontSize: {
      fontSize: '2rem',
    },
  })
);
const ArrowDrop = (props) => {
  const classes = useStyles();
  return (
    <div
      {...props.innerProps}
      className={`${classes.dropdown} ${
        props.propertyName === props.hover || props.active
          ? classes.show
          : classes.hide
      }`}
    >
      <ArrowDropUpIcon
        viewBox="1 -9 24 24"
        className={`${classes.arrowFontSize}`}
        color={
          props.active && props.direction === 'asc' ? 'primary' : 'disabled'
        }
      />
      <ArrowDropDownIcon
        viewBox="1 9 24 24"
        className={`${classes.arrowFontSize}`}
        color={
          props.active && props.direction === 'desc' ? 'primary' : 'disabled'
        }
      />
    </div>
  );
};

const TableContentHeading = ({
  styles,
  orderBy,
  order,
  setStateAction,
  state,
  sortData,
  uoaEndRef,
}) => {
  return (
    <TableRow style={{ height: '40px' }}>
      {window.innerWidth > 1500 && (
        <TableCell style={styles.headerCell} align="left" className="sticky">
          <TableSortLabel
            onMouseOver={() => {
              setStateAction({
                hoverTabelSortLabel: 1,
              });
            }}
            onMouseOut={() => {
              setStateAction({
                hoverTabelSortLabel: '',
              });
            }}
            style={{ color: '#000' }}
            active={orderBy === 'CompanyName'}
            direction={orderBy === 'CompanyName' ? order : 'asc'}
            onClick={() => sortData('CompanyName')}
            IconComponent={() => (
              <ArrowDrop
                orderBy={orderBy}
                active={orderBy === 'CompanyName'}
                hover={state.hoverTabelSortLabel}
                propertyName={1}
                direction={orderBy === 'CompanyName' ? order : 'asc'}
              />
            )}
          >
            Company
          </TableSortLabel>
        </TableCell>
      )}

      {data &&
        data.map((item, i) => {
          return (
            <TableCell
              key={item.id}
              style={{
                ...styles.headerCell,
                width: i === 0 && window.innerWidth < 1500 ? '40px' : '',
              }}
              align={item.align}
              className="sticky"
            >
              <TableSortLabel
                onMouseOver={() => {
                  setStateAction({
                    hoverTabelSortLabel: item.id,
                  });
                }}
                onMouseOut={() => {
                  setStateAction({
                    hoverTabelSortLabel: '',
                  });
                }}
                style={{ color: '#000' }}
                active={orderBy === item.orderBy}
                direction={orderBy === item.orderBy ? order : item.order}
                onClick={() => sortData(item.orderBy)}
                IconComponent={() => (
                  <ArrowDrop
                    orderBy={orderBy}
                    active={orderBy === item.orderBy}
                    hover={state.hoverTabelSortLabel}
                    propertyName={item.propertyName}
                    direction={orderBy === item.orderBy ? order : item.order}
                  />
                )}
              >
                {item.title}
              </TableSortLabel>
            </TableCell>
          );
        })}
    </TableRow>
  );
};
export default TableContentHeading;



// WEBPACK FOOTER //
// ./src/Pages/UnusualOptionsActivity/components/tables/tableContentHeading.jsx